import React, { useState, useContext, useEffect } from 'react'
import {
  Button, Input, Radio
} from 'semantic-ui-react'
import { getClient } from '../../../utils/functions'
import { HTTP, AppContext } from '../../../providers'

const SyncedRow = ({ save, close, args }) => {
  const { beeAPI, theme } = useContext(AppContext)
  const [name, setName] = useState('')
  const { store, dispatch } = beeAPI
  const { client } = store

  useEffect(() => {
    const client = getClient()
    HTTP.get(`${client.demoAPI}/listRows`)
      .then(({ data }) => {
        const row = data.find(row => {
          return row.guid === args.metadata.guid
        })
        console.log('row: ', row)
        setName(row?.id)
      })
  }, [])


  const onHandleSave = () => {
    save({ isSynced: true, guid: name })
  }

  const onHandleClose = () => {
    save({ isSynced: false })
  }

  return (
    <>
      <div>
        {
          name
            ? (<p></p>)
            : (<p style={{
              fontSize: '12px',
              color: '#666666',
              padding: '0.85714em',
              paddingLeft: '1.85714em'
            }} >Loading row...</p >)
        }
      </div>
      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}
      >
        {
          name
            ? (<>
              <Button inverted={theme.inverted} color={theme.button.primary} onClick={onHandleSave}>
                <i className="save icon"></i> Edit and update everywhere
              </Button>
              <Button inverted={theme.inverted} color={theme.button.secondary} onClick={onHandleClose}>
                <i className="close icon"></i> Unsync this row
              </Button>
            </>)
            : (<p></p>)
        }
      </div>
    </>
  )
}

export default SyncedRow
